<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-undo`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.121 24.778a1 1 0 010 1.414l-1.414 1.415a1 1 0 01-1.414 0L4.1 18.414a2 2 0 010-2.828l9.192-9.193a1 1 0 011.414 0l1.414 1.415a1 1 0 010 1.414l-5.778 5.777L29.586 15c7.732 0 14 6.268 14 14s-6.268 14-14 14h-8.729a1 1 0 01-1-1v-1.96a1 1 0 011-1h8.26c3.865 0 10-4.001 10-10.04 0-6.039-6.135-10-10-10H10.343l5.777 5.778z"/></svg>
</template>
<script>

export default {
  name: 'IconUndo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
